import * as FutureFragment from "@eyeo-fragments/in-product-messaging/background";
import * as LegacyFragment from "@eyeo-fragments/ipm-legacy/background";
function setCommandActor(commandName, actor) {
    FutureFragment.setCommandActor(commandName, actor);
}
export function getFutureFragmentOverrides() {
    return {
        checkLanguage: async () => { },
        defaultLicenseState: LegacyFragment.LicenseState.inactive,
        doesLicenseStateMatch: async () => true,
        isValidLicenseStateList: () => true,
        setCommandActor,
    };
}
